import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { deleteCategory } from '../../services/AdminCategoryService';

const CategoryDeleteModal = ({ isOpen, onClose, onSuccess, category }) => {
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    setLoading(true);
    try {
      await deleteCategory(category.id);
      await onSuccess();
      onClose();
    } catch (error) {
      console.error('Error deleting category:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
            <div className="admin__modal-body__delete_categories">
              <p>Are you sure you want to delete the category <strong>{category.name}</strong> with <strong>ID #{category.id}</strong>? All products currently assigned to this category will be moved to the default <strong>Uncategorized</strong> category.</p>
            </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryDeleteModal;